import React, { useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import elementClass from 'element-class';
import PhotoEditor from './PhotoEditor';

const PhotoEditorContainer = ({ containerClassName, ...props }) => {
  const node = useRef(document.createElement('div'));

  useEffect(() => {
    node.current.className = containerClassName;
    document.body.appendChild(node.current);
    elementClass(document.body).add('image-editor-open');

    const currentNode = node.current;
    return () => {
      document.body.removeChild(currentNode);
      elementClass(document.body).remove('image-editor-open');
    };
  }, [containerClassName]);

  const { photoId, ...restProps } = props;
  return createPortal(
    <PhotoEditor photoId={parseInt(photoId, 10)} {...restProps} />,
    node.current,
  );
};

PhotoEditorContainer.defaultProps = {
  containerClassName: 'companycam-webeditor-container',
};

export default PhotoEditorContainer;
